import httpClient from './httpClient'

export default {
  async getIntegrations() {
    let ret = await httpClient.get('forms-integration/get')
    return ret
  },
  async saveIntegration(data) {
    let ret = await httpClient.post('forms-integration/save', data)
    return ret
  },
  async updateIntegration(data) {
    let ret = await httpClient.put('forms-integration/update', data)
    return ret
  },
  async deleteIntegration(integrationId) {
    let ret = await httpClient.delete(
      `forms-integration/delete/${integrationId}`
    )
    return ret
  },
}
